import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../Firebase/Firebase';
import Navbar from '../../Components/NavBarV2';
import Footer from '../../Components/footer';
import './AdministrarEspacio.css';

const EditarEspacio = () => {
  const { idMarca, idLugar, idEspacio } = useParams();
  const navigate = useNavigate();
  const [espacio, setEspacio] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEspacio = async () => {
      try {
        
        const ref = doc(db, 'marca', idMarca, 'lugar', idLugar, 'espacio', idEspacio);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          setEspacio(snap.data());
        } else {
          alert('❌ Espacio no encontrado');
        }
      } catch (err) {
        console.error('Error al cargar espacio:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchEspacio();
  }, [idMarca, idLugar, idEspacio]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEspacio((prev) => ({ ...prev, [name]: value }));
  };

  const handleGuardar = async () => {
    try {
      const ref = doc(db, 'marca', idMarca, 'lugar', idLugar, 'espacio', idEspacio);
      await updateDoc(ref, {
        ...espacio,
        ultimaActualizacion: new Date(),
      });
      alert('✅ Espacio actualizado correctamente');
      navigate(`/proveedor/marca/${idMarca}/lugar/${idLugar}`);
    } catch (err) {
      console.error('Error al guardar:', err);
      alert('❌ Error al actualizar el espacio');
    }
  };

  if (loading || !espacio) return <p>Cargando...</p>;

  return (
    <>
      <Navbar />
      <div className="editar-espacio-container">
        <h2>Editar Espacio</h2>

        <label>Nombre del Espacio:</label>
        <input name="NombreEspacio" value={espacio.NombreEspacio} onChange={handleChange} />

        <label>Accesorios:</label>
        <input name="Accesorios" value={espacio.Accesorios} onChange={handleChange} />

        <label>Capacidad Mínima:</label>
        <input type="number" name="CapacidadMin" value={espacio.CapacidadMin} onChange={handleChange} />

        <label>Capacidad Máxima:</label>
        <input type="number" name="CapacidadMax" value={espacio.CapacidadMax} onChange={handleChange} />

        <label>Color:</label>
        <input type="color" name="Color" value={espacio.Color} onChange={handleChange} />

        <label>Descripción:</label>
        <textarea name="DescripcionEspacio" value={espacio.DescripcionEspacio} onChange={handleChange} />

        <label>Latitud:</label>
        <input value={espacio.latitud} readOnly disabled />

        <label>Longitud:</label>
        <input value={espacio.longitud} readOnly disabled />

        {espacio.Imagenes && espacio.Imagenes.length > 0 && (
          <div className="galeria-imagenes">
            <h4>Imágenes:</h4>
            {espacio.Imagenes.map((url, i) => (
              <img key={i} src={url} alt={`img-${i}`} />
            ))}
          </div>
        )}

        <button onClick={handleGuardar}>Guardar Cambios</button>
      </div>
      <Footer />
    </>
  );
};

export default EditarEspacio;
